<template>
  <router-view />
</template>
<script>
  export default {
    computed : {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
      userDetails() { return this.$store.state.userDetails}
    },
    mounted() {
      if(this.isLoggedIn && this.userDetails != undefined) {
        this.$store.dispatch('getUserData');
      } else {
        this.$router.push('/login')
      }
    },
    methods: {
      logout: function () {
        this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
      }
    },
    created: function () {
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch(logout)
          }
          throw err;
        });
      });
    }
  }
</script>

<style lang="scss">
@import '@/style/base.scss';
</style>
